import React from "react";

// Darker bottom-border shade per README answer-tile colour set.
const DARKER = {
  "#F2506E": "#C23252",
  "#4F86E0": "#2F5FB0",
  "#37A65B": "#22874E",
  "#8B5CF6": "#6A3FD0",
};

/**
 * Shared quiz answer tile. letter: "A"/"B"/"C"/"D" or "أ"/"ب"/"ج"/"د".
 * state: "idle" | "correct" | "wrong" | "dim".
 */
export default function OptionTile({ letter, children, state = "idle", color = "#4F86E0", onClick, className = "" }) {
  const isCorrect = state === "correct";
  const isWrong = state === "wrong";
  const isDim = state === "dim" || isWrong;
  const darker = DARKER[color] || color;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={state !== "idle"}
      className={
        "w-full flex items-center gap-3 rounded-2xl px-4 py-3.5 min-h-[44px] text-start " +
        "font-body font-bold text-[15px] transition " +
        (isDim ? "opacity-50 " : "") +
        className
      }
      style={{
        background: isCorrect ? "#DFF5E6" : "#fff",
        borderBottom: `5px solid ${isCorrect ? "#22874E" : darker}`,
        color: isCorrect ? "#22874E" : "#2A2620",
      }}
    >
      <span
        className="flex items-center justify-center rounded-full font-display font-semibold shrink-0"
        style={{
          width: 32,
          height: 32,
          background: isCorrect ? "#37A65B" : color,
          color: "#fff",
          fontSize: 14,
        }}
      >
        {isCorrect ? "✓" : letter}
      </span>
      <span className="flex-1">{children}</span>
    </button>
  );
}
